/*
  ============================================================
  anobre-quantidade.js — seletor de quantidade e limite de estoque
  ============================================================

  POR QUE ESTE ARQUIVO EXISTE:
  O binding dos botoes +/- vivia dentro do script de variantes, DEPOIS
  de `if (!form || !jsonEl) return`. Produto de variante unica nao
  renderiza o bloco data-variant-json, entao o script retornava antes e
  os botoes nunca eram ligados — em TODOS os produtos da Pronta Entrega.
  Aqui eles nao dependem de variante nenhuma.

  O QUE FAZ:
  1. Liga os botoes + e - do seletor de quantidade.
  2. Quando ha limite de estoque, avisa ao ultrapassar e BLOQUEIA o
     "Adicionar ao carrinho", deixando so o caminho do WhatsApp.

  POR QUE BLOQUEAR E NAO SO AVISAR:
  Antes o aviso aparecia e a compra seguia mesmo assim. O Shopify
  recusaria no checkout, mas so depois de a pessoa ter preenchido tudo —
  erro tardio e frustrante. Bloquear aqui devolve a decisao antes.
*/
(function () {
  // --- 1. botoes de quantidade ---------------------------------------
  document.querySelectorAll('.quantity-selector').forEach(function (sel) {
    var input = sel.querySelector('.quantity__input');
    if (!input) return;
    var mais = sel.querySelector('[name="plus"]');
    var menos = sel.querySelector('[name="minus"]');

    function ajusta(delta) {
      var atual = parseInt(input.value || '1', 10);
      if (isNaN(atual)) atual = 1;
      input.value = Math.max(1, atual + delta);
      // 'change' e nao 'input': e o evento que o Shopify e o restante do
      // tema escutam, e o que faz o limite de estoque reavaliar.
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (mais) mais.addEventListener('click', function () { ajusta(1); });
    if (menos) menos.addEventListener('click', function () { ajusta(-1); });
  });

  // --- 2. faixa de quantidade (Loja para Personalizar) -----------------
  // Minimo por modelo e teto acima do qual o pedido sai do site. O
  // bloqueio e do botao, nao do campo: impedir de DIGITAR esconderia o
  // motivo. A pessoa ve o numero que quis, le por que nao da, e recebe o
  // caminho do WhatsApp.
  (function () {
    var campo = document.querySelector('input[name="quantity"][data-anobre-min]');
    if (!campo) return;

    var minimo = parseInt(campo.getAttribute('data-anobre-min'), 10) || 1;
    var maximo = parseInt(campo.getAttribute('data-anobre-max'), 10) || 0;
    if (minimo <= 1 && maximo <= 0) return;

    var faixa = document.querySelector('[data-anobre-faixa]');
    var avisoMin = faixa && faixa.querySelector('[data-anobre-faixa-min]');
    var avisoMax = faixa && faixa.querySelector('[data-anobre-faixa-max]');
    var ctaMax = faixa && faixa.querySelector('[data-anobre-faixa-cta]');
    var add = document.querySelector('.product__add-to-cart');

    function avaliar() {
      var q = parseInt(campo.value, 10);
      var abaixo = !isNaN(q) && q < minimo;
      var acima = maximo > 0 && !isNaN(q) && q > maximo;

      if (avisoMin) avisoMin.hidden = !abaixo;
      if (avisoMax) avisoMax.hidden = !acima;
      if (ctaMax) ctaMax.hidden = !acima;

      if (add) {
        var trava = abaixo || acima;
        add.disabled = trava;
        add.setAttribute('aria-disabled', trava ? 'true' : 'false');
      }
    }

    campo.addEventListener('input', avaliar);
    campo.addEventListener('change', avaliar);
    avaliar();
  })();

  // --- 3. limite de estoque -------------------------------------------
  var caixa = document.querySelector('[data-anobre-estoque]');
  if (!caixa) return;

  var disponivel = parseInt(caixa.getAttribute('data-disponivel'), 10);
  if (!disponivel || disponivel < 1) return;

  var campo = document.querySelector('input[name="quantity"]');
  if (!campo) return;

  var aviso = caixa.querySelector('[data-anobre-estoque-aviso]');
  var cta = caixa.querySelector('[data-anobre-estoque-cta]');
  var botaoAdicionar = document.querySelector('.product__add-to-cart');

  function avaliar() {
    var pedido = parseInt(campo.value, 10);
    var excede = !isNaN(pedido) && pedido > disponivel;

    if (aviso) aviso.hidden = !excede;
    if (cta) cta.hidden = !excede;

    if (botaoAdicionar) {
      botaoAdicionar.disabled = excede;
      // aria-disabled alem de disabled: leitor de tela anuncia o estado
      // em vez de simplesmente pular o botao.
      botaoAdicionar.setAttribute('aria-disabled', excede ? 'true' : 'false');
    }
  }

  campo.addEventListener('input', avaliar);
  campo.addEventListener('change', avaliar);
  avaliar();
})();
